import Navbar from './components/Navbar/Navbar';
import { BioContextProvider } from './store/bio-context';
import ThemeContext from './store/theme-context';
import { useContext } from 'react';
import Home from './components/Home';
import Footer from './components/Footer/Footer';
import AllBlogs from './components/Blogs/AllBlogs';
import AllProjects from './components/Projects/AllProjects';
import AllVideos from './components/Videos/AllVideos';
import Contact from './components/Contact/Contact';

import { BrowserRouter as Router, Routes, Route  } from "react-router-dom";
import PageNotFound from './components/PageNotFound';

function App() {
  const theme = useContext(ThemeContext);

  return (
      <div className="container" style={{background: theme.currentTheme.background, color: theme.currentTheme.color}}>
        <div className="App">
          <BioContextProvider>
          <Router>
            <Navbar/>
              <Routes>
                  <Route path='/' element={<Home />}/>
                  <Route path='/blogs' element={<AllBlogs />}/>
                  <Route path='/projects' element={<AllProjects />}/>
                  <Route path='/videos' element={<AllVideos />}/>
                  <Route path='/contact' element={<Contact />}/>
                  <Route path="/*" element={<PageNotFound/>} />
              </Routes>
            </Router>
            
            <Footer/>
          </BioContextProvider>
        </div>
        
      </div>
  );
}

export default App;
